import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import RichEditor from "./components/RichEditor";
import RichEditorSettings from "./components/RichEditorSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/rich_editor_settings.svg";
import { getLocale, defaultTarget } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'richEditor', // 插件名，不能包含空格,空格用-代替
    group: ElementGroup.INPUT, // 插件所在组，默认为ElementGroup.CUSTOM
    target: defaultTarget, // 插件所在目标层级，默认为["column", "row", "form"]
    title: messages['PAGEBUIDER_ELEMENT_FORM_RICHEDITOR'], // 插件标题
    toolBarPreview: <PluginSvg />, // 插件展示图标，不传则展示文字
    data: { // 插件初始化数据
      formItemSettings: {
        // defaultValue: '<div>hello world</div>',
        readOnly: false
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_RICHEDITOR']
      },
      settings: {
        height: {
          value: "180px"
        },
      }
    },
    pluginComponent: RichEditor, // 插件渲染组件
    pluginSettingComponent: RichEditorSettings, // 插件设置项组件
  }
}
